import styled from 'styled-components';
import { AnchorButton } from '@blueprintjs/core';
import { Col } from 'react-flexbox-grid';
import { VDraggableDialog } from 'welltrax-ui-components';

interface IBodyContainerManageFilters {
  iconOnly?: boolean;
}

export const BodyContainerManageFilters = styled.div`
  height: 100%;
  width: 100%;
  padding: ${(props: IBodyContainerManageFilters) => (props.iconOnly ? '0' : '10px 0 0')};
  position: absolute;

  & > div {
    height: 100%;
    width: 100%;
    & > div:last-child {
      height: 100%;
    }
  }
`;
export const BodyContainerGridProfile = styled.div`
  height: 100%;
  padding: 10px;
  & > div {
    height: 100%;
  }
`;

interface ICustomAnchorButton {
  textcolor?: string;
}

export const CustomAnchorButton = styled(AnchorButton)`
  & svg {
    color: ${(props: ICustomAnchorButton) => props.textcolor && props.textcolor};
    opacity: 1;
  }
  & svg:disabled {
    color: ${(props: ICustomAnchorButton) => props.textcolor && props.textcolor};
    opacity: 0.8;
  }
`;

export const DialogProfile = styled(VDraggableDialog)`
  padding: 0;
  width: 600px;
  max-height: calc(100vh - 60px);
  overflow: auto;
`;

export const FilterCol = styled(Col)`
  border-right: 1.5px dotted gray;
  padding: 5px !important;
  height: 35px;
  margin-top: 5px;
  &:last-child {
    border-right: none;
  }
  &:only-child {
    border-right: none;
  }
`;
interface IFilterLabel {
  width?: string;
}

export const FilterLabel = styled.div`
  width: ${(props: IFilterLabel) => props?.width ?? '130px'};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  padding-left: 5px;
  margin-top: 5px;
`;

interface IStyledDragAndDropListContainer {
  disabled?: boolean;
}

export const StyledDragAndDropListContainer = styled.div`
  opacity: ${(props: IStyledDragAndDropListContainer) => (props.disabled ? 0.9 : 1)};
  height: 100%;
`;

interface IAdvanceSectionContainerStyle {
  advance?: boolean;
  isHideSection?: boolean;
}

export const AdvanceSectionContainerStyle = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & .advance-section {
    max-width: 200px;
  }

  & .collapse-advance-section {
    width: ${(props: IAdvanceSectionContainerStyle) => (props?.isHideSection ? '100%' : props.advance ? '90%' : '98%')};
    align-self: ${(props: IAdvanceSectionContainerStyle) => !props.advance && 'normal'};
  }
`;

interface IVirtualItemStyle {
  count: number;
  type: 'FILTER' | 'CONDITIONAL';
}

export const VirtualItemStyle = styled.div`
  display: grid;
  grid-template-columns: ${(props: IVirtualItemStyle) =>
    !!props.count ? `repeat(${props.count}, ${100 / props.count}%)` : 'auto'};
  grid-template-rows: auto;
  grid-gap: 2px;
  width: ${(props: IVirtualItemStyle) => (props.type === 'FILTER' ? '99% !important' : '100%')};
`;
